import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useFooterContext } from 'contexts/footer-context';
import Tooltip from './tooltip';

export default function Footer() {
  const {
    onBack,
    onNext,
    backText = 'Back',
    nextText = 'Next',
    nextDisabled = false,
    nextDisabledReason,
    nextVariant = 'blue',
    showBackArrow = false,
    nextAdornment,
    alternateNextButton,
    secondaryButton
  } = useFooterContext();

  if (!onBack && !onNext) {
    return null;
  }

  const nextButtonClasses = clsx(
    'w-full px-4 py-2 text-sm font-semibold rounded-lg text-white flex items-center justify-center gap-1',
    nextDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    nextVariant === 'green'
      ? 'bg-green-500 hover:bg-green-600'
      : 'bg-blue-500 hover:bg-blue-600'
  );

  return (
    <div className='relative flex w-full justify-center gap-4 border-t border-gray-200 bg-white px-5 py-3'>
      {alternateNextButton && (
        <div className='w-[160px] opacity-0'>
          <span className='py-2 text-sm font-semibold'>
            {alternateNextButton.text}
          </span>
        </div>
      )}
      {onBack && (
        <div className='w-[160px]'>
          <button
            type='button'
            className='flex w-full items-center justify-center gap-1 rounded-lg bg-blue-500 py-2 text-sm font-semibold text-white hover:bg-blue-600'
            onClick={onBack}
          >
            {showBackArrow && <ArrowLeftIcon className='h-5 w-5' />}
            <span>{backText}</span>
          </button>
        </div>
      )}
      {secondaryButton && (
        <div className='flex items-center'>
          <button
            type='button'
            className='relative cursor-pointer rounded-lg bg-blue-500 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-600'
            onClick={secondaryButton.onClick}
          >
            {secondaryButton.text}
            {secondaryButton.tooltip && (
              <Tooltip text={secondaryButton.tooltip} />
            )}
          </button>
        </div>
      )}
      {onNext && (
        <div id='footer-next-button' className='relative min-w-[160px]'>
          <button
            type='button'
            className={nextButtonClasses}
            onClick={onNext}
            disabled={nextDisabled}
          >
            <span>{nextText}</span>
            {nextAdornment}
          </button>
          {nextDisabled && nextDisabledReason && (
            <Tooltip text={nextDisabledReason} />
          )}
        </div>
      )}
      {alternateNextButton && (
        <div className='relative w-[160px]'>
          <button
            type='button'
            className={clsx(
              'flex w-full items-center justify-center gap-1 rounded-lg py-2 text-sm font-semibold text-white',
              alternateNextButton.disabled
                ? 'cursor-not-allowed opacity-50'
                : 'cursor-pointer',
              'bg-green-500 hover:bg-green-600'
            )}
            onClick={alternateNextButton.onClick}
            disabled={alternateNextButton.disabled}
          >
            {alternateNextButton.text}
          </button>
          {alternateNextButton.disabled &&
            alternateNextButton.disabledReason && (
              <Tooltip text={alternateNextButton.disabledReason} />
            )}
        </div>
      )}
    </div>
  );
}
